var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "22px",
    viewBox: "0 0 29 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Delete_1234815-Copy",
    transform: "translate(5.000000, 1.000000)",
    fill: "#645A5B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8.5224641,
    y: 7.81334899,
    width: 1.06530801,
    height: 7.752452
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9983789,2.6185707 L12.3309403,2.6185707 L12.3309403,0.0661923838 L5.77929597,0.0661923838 L5.77929597,2.6185707 L0.111857341,2.6185707 L0.111857341,3.67764885 L2.05870774,3.67764885 L2.05870774,20.0562923 L16.0515285,20.0562923 L16.0515285,3.67764885 L17.9983789,3.67764885 L17.9983789,2.6185707 Z M6.84460398,1.12527053 L11.2656322,1.12527053 L11.2656322,2.6185707 L6.84460398,2.6185707 L6.84460398,1.12527053 Z M14.9862205,18.9972142 L3.12401575,18.9972142 L3.12401575,3.67764885 L14.9862205,3.67764885 L14.9862205,18.9972142 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5.32654006,
    y: 7.81334899,
    width: 1.06530801,
    height: 7.752452
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.7183881,
    y: 7.81334899,
    width: 1.06530801,
    height: 7.752452
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic-delete.72bc8c7a4276c98da14c10845939b0d2.svg";
export { ForwardRef as ReactComponent };